<div class="animated fadeIn rounded">
    <div class="card">
        <div class="card-header">
            <i class="fa fa-plus"></i> Creación de Orden de Devolución de Factura MT
            <div class="card-header-actions btn-group" dropdown placement="bottom left">
                <button type="button" (click)="observations()" [disabled]="!isLoaded"
                    class="btn btn-sm btn-outline-success"><i
                        class="fa fa-pen-to-square"></i>&nbsp;Observaciones</button>
            </div>
        </div>
        <div class="card-body">
            <div class="form-group row">
                <div class="col-md-12">
                    <button type="button" (click)="create()" [disabled]="!isLoaded"
                        class="btn btn-outline-success float-right"><i class="fa fa-plus"></i>&nbsp;Crear</button>
                </div>
            </div>
            <accordion [isAnimated]="true">
                <accordion-group [isOpen]="true">
                    <span accordion-heading>
                        <i class='fa fa-users'></i> Factura o Recibo a ingresar
                    </span>
                    <form #invoiceForm="ngForm" (ngSubmit)="invoiceForm.valid && searchInvoice()">

                        <div class="row">
                            <div class="col-md-6">
                                <label class="col-form-label"><b>Número de Factura MT</b></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 input-group">
                                <input type="text" id="invoice-number-manual" name="invoice-number-manual"
                                    class="form-control" #invoiceManualModel="ngModel" [(ngModel)]="invoiceCode"
                                    mask="000-000-00-00000000" [showMaskTyped]="true" [dropSpecialCharacters]="false"
                                    [disabled]="this.isLoaded">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="submit"><i
                                            class="fa fa-search"></i></button>
                                </div>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" (click)="clear()"><i
                                            class="fa fa-trash"></i></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </accordion-group>
                <accordion-group [isOpen]="true">
                    <span accordion-heading>
                        <i class='fa fa-users'></i> Información General
                    </span>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>CAI</b></label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" [(ngModel)]="invoice.cai" [disabled]="!isLoaded"
                                required>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Fecha de Factura</b></label>
                        <div class="col-md-9">
                            <input bsDatepicker class="form-control"
                                [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }"
                                [(ngModel)]="invoiceDateSelected" [disabled]="!isLoaded" required>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Condición</b></label>
                        <div class="col-md-9">
                            <ng-select [items]="conditions" bindLabel="description" [(ngModel)]="conditionSelected"
                                [disabled]="!isLoaded" required>
                            </ng-select>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="conditionSelected.code == 'credito'">
                        <label class="col-md-3 col-form-label"><b>Contrato</b></label>
                        <div class="col-md-9">
                            <input type="text" id="contract-number" name="contract-number" class="form-control"
                                [(ngModel)]="contractNumber" [disabled]="!isLoaded" required>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Exonerada/Exenta</b></label>
                        <div class="col-md-9">
                            <ng-select [items]="exoneratedReasons" bindLabel="reason"
                                [(ngModel)]="exoneratedReasonSelected" [disabled]="!isLoaded">
                            </ng-select>
                        </div>
                    </div>
                    <!-- <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Cliente</b></label>
                        <div class="col-md-9">
                            <input type="text"  class="form-control" disabled
                                [(ngModel)]="customerInformation">
                        </div>
                    </div> -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Cliente</b></label>
                        <div class="col-md-9 input-group">
                            <input type="text" class="form-control" [(ngModel)]="customerInformation" readonly>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button"
                                    (click)="handleSearchCustomerClick()"><i class="fa fa-search"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"><b>Vendedor</b></label>
                        <div class="col-md-9 input-group">
                            <input type="text" class="form-control" [(ngModel)]="sellerInformation" readonly>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button"
                                    (click)="handleSearchSellerCLick()"><i class="fa fa-search"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label" for="text-input"><b>Motivo de Devolución</b></label>
                        <div class="col-md-9">
                            <ng-select [items]="cancellationReasons" bindLabel="description"
                                [(ngModel)]="cancellationReasonSelected" required [disabled]="!isLoaded"></ng-select>
                        </div>
                    </div>
                </accordion-group>
                <accordion-group [isOpen]="true">
                    <span accordion-heading>
                        <i class='fa fa-cart-shopping'></i> Productos
                    </span>
                    <div class="row">
                        <div class=" col-12 mb-3 card-header-actions btn-group" dropdown placement="bottom left">
                            <button type="button" (click)="addProduct()" [disabled]="!isLoaded"
                                class="btn btn-sm btn-success"><i class="fa fa-plus"></i>&nbsp;Agregar Producto</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <pos-table tableFormId="productsCartTable" [data]="productsCart"
                                [headers]="getProductCartHeaders()" [filters]="[]" [itemsPerPage]="10"
                                [pagination]="false" [disableHighlight]="true" (dataSave)="saveProductCart($event)">
                            </pos-table>
                        </div>
                    </div>
                </accordion-group>
            </accordion>
        </div>
    </div>

</div>